<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 50 38"
  >
    <defs />
    <path
      fill="#0071c0"
      d="M44 0H6a6 6 0 00-6 6v25a6 6 0 006 7h38a6 6 0 006-7V6a6 6 0 00-6-6z"
    />
    <path
      fill="#99c6e5"
      d="M32 12v1c-1 4-4 6-8 6h-1a1 1 0 00-1 1l-1 7-1 1a1 1 0 001 1h3a1 1 0 001-1l1-4a1 1 0 011-1c4 0 6-2 7-6a5 5 0 00-1-4 3 3 0 00-1-1z"
    />
    <path
      fill="#cce2f2"
      d="M31 13a11 11 0 00-2 0h-5a1 1 0 00-1 0l-1 8a1 1 0 011-1h2c3 0 6-1 7-6v-1h-1z"
    />
    <path
      fill="#fff"
      d="M23 13a1 1 0 011 0h5a11 11 0 012 0h1q1 0 0 0a5 5 0 011 0 5 5 0 00-1-4l-5-1h-7a1 1 0 00-1 1l-3 18a1 1 0 001 1h4l1-7z"
    />
  </svg>
</template>
